export const navLinks = [
  {
    label: "ACESSO PACIENTE",
    href: "https://www.trataz.com.br/login",
    active: true,
  },
  {
    label: "ACESSO PROFISSIONAL",
    href: "https://www.trataz.com.br/login",
  },
  {
    label: "CADASTRO PROFISSIONAL",
    href: "https://www.trataz.com.br/register",
  },
  {
    label: "ENCONTRE UM PROFISSIONAL",
    action: "findProfessional",
  },
  {
    label: "ATENDIMENTO TRATAZ",
    href: "https://wa.me/5547996912977",
  },
];

export const sectionTwoProblems = [
  { src: "/novas-imagens/section-two/1.png", label: "ESQUECE ORIENTAÇÕES" },
  { src: "/novas-imagens/section-two/3.png", label: "PACIENTE NÃO ENTENDE" },
  { src: "/novas-imagens/section-two/4.png", label: "SEM REGISTRO" },
  { src: "/novas-imagens/section-two/2.png", label: "FALTA DE ADESÃO" },
];

export const sectionFourCards = [
  {
    src: "/novas-imagens/section-four/image-one.png",
    title: "DIDÁTICO",
  },
  {
    src: "/novas-imagens/section-four/image-two.png",
    title: "AUTONOMIA",
  },
  {
    src: "/novas-imagens/section-four/image-three.png",
    title: "FLEXIBILIDADE",
  },
];

export const sectionFiveCards = [
  "/novas-imagens/section-five/image-one.png",
  "/novas-imagens/section-five/image-two.png",
  "/novas-imagens/section-five/image-three.png",
  "/novas-imagens/section-five/image-four.png",
];

export const sectionSevenStats = [
  {
    title: "500+",
    label: "PROFISSIONAIS ATIVOS",
  },
  {
    title: "300%",
    label: "ENGAJAMENTO DO PACIENTE",
  },
  {
    title: "40%",
    label: "ECONOMIA DE TEMPO",
  },
];

export const sectionEightLogos = [
  "/novas-imagens/section-eight/logo-one.png",
  "/novas-imagens/section-eight/logo-two.png",
  "/novas-imagens/section-eight/logo-three.png",
  "/novas-imagens/section-eight/logo-four.png",
  "/novas-imagens/section-eight/logo-five.png",
  "/novas-imagens/section-eight/fapesp.png",
];

export const differencesItems = [
  {
    src: "/novas-imagens/popup-differences/icon-one.png",
    label: "CONSULTA\nINTELIGENTE",
  },
  {
    src: "/novas-imagens/popup-differences/icon-two.png",
    label: "LEMBRETES\nAUTOMÁTICOS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-three.png",
    label: "CONTEÚDOS\nPRONTOS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-four.png",
    label: "MAIS TEMPO CLÍNICO",
  },
  { src: "/novas-imagens/popup-differences/icon-five.png", label: "IA TRATI" },
  {
    src: "/novas-imagens/popup-differences/icon-six.png",
    label: "CRIE, SALVE E\nREUTILIZE\nTRATAMENTOS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-seven.png",
    label: "ORIENTAÇÕES REGISTRADAS\nE VINCULADAS AO SEU\nATENDIMENTO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-eight.png",
    label: "VALIDAÇÃO DO\nPACIENTE",
  },
  {
    src: "/novas-imagens/popup-differences/icon-nine.png",
    label: "TUDO DOCUMENTADO\nPARA SUA PROTEÇÃO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-ten.png",
    label: "SEGURANÇA E\nREGISTRO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-eleven.png",
    label: "VOCÊ VALIDA. O PACIENTE\nEXECUTA MELHOR",
  },
  {
    src: "/novas-imagens/popup-differences/icon-twelve.png",
    label: "ORIENTAÇÕES\nEM PDF",
  },
  {
    src: "/novas-imagens/popup-differences/icon-thirteen.png",
    label: "MAIS ADESÃO,\nMENOS\nESQUECIMENTO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-fourteen.png",
    label: "EVOLUÇÃO\nREGISTRADA COM\nFACILIDADE",
  },
  {
    src: "/novas-imagens/popup-differences/icon-fifteen.png",
    label: "ENTREGA CLARA E\nPROFISSIONAL",
  },
  {
    src: "/novas-imagens/popup-differences/icon-sixteen.png",
    label: "MENOS REPETIÇÃO,\nMAIS RESULTADO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-seventeen.png",
    label: "APOIO RÁPIDO PARA\nDECISÕES CLÍNICAS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-eighteen.png",
    label: "CONTINUIDADE DO\nCUIDADO",
  },
  {
    src: "/novas-imagens/popup-differences/icon-nineteen.png",
    label: "RELATÓRIOS\nAUTOMÁTICOS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-twenty.png",
    label: "SEU PACIENTE NÃO\nSE PERDE",
  },
  {
    src: "/novas-imagens/popup-differences/icon-twenty-one.png",
    label: "SEGURANÇA\nPROFISSIONAL",
  },
  {
    src: "/novas-imagens/popup-differences/icon-twenty-two.png",
    label: "+300 VÍDEOS E\nORIENTAÇÕES\nCLÍNICAS",
  },
  {
    src: "/novas-imagens/popup-differences/icon-twenty-three.png",
    label: "SUA CONSULTA\nORGANIZADA\nAUTOMATICAMENTE",
  },
];

export const faqItems = [
  {
    title: "COMO FUNCIONA O PERÍODO DE TESTE GRATUITO?",
    description:
      "A plataforma oferece 14 dias gratuitos para que você teste todos os recursos com até 5 pacientes, sem compromisso e sem necessidade de cartão de crédito para começar.",
  },
  {
    title: "OS PACIENTES PRECISAM PAGAR PARA USAR O APLICATIVO?",
    description:
      "Não. Seus pacientes têm acesso gratuito ao aplicativo móvel e a todos os materiais que você compartilhar. Basta baixar o app e utilizar o código que você fornecer.",
  },
  {
    title: "É SEGURO PARA OS DADOS DOS PACIENTES?",
    description:
      "Sim. A plataforma segue rigorosamente a LGPD, com todas as informações criptografadas e armazenadas com segurança na nuvem, além de contar com certificações de segurança e backup automático.",
  },
  {
    title: "COMO FUNCIONAM OS LEMBRETES AUTOMÁTICOS?",
    description:
      "A plataforma envia lembretes por WhatsApp e e-mail nos horários que você configura. Os pacientes recebem notificações sobre exercícios, consultas e marcos importantes do tratamento.",
  },
  {
    title: "A TRATAZ FUNCIONA PARA QUALQUER ESPECIALIDADE?",
    description:
      "Sim, inicialmente foi desenvolvida para a área de fonoaudiologia e odontologia, porém é uma ferramenta poderosa para controle e engajamento do paciente, com materiais dinâmicos. Se quiser saber como criar materiais para sua área, é só falar conosco.",
  },
  {
    title: "COMO FUNCIONA O SUPORTE TÉCNICO?",
    description:
      "O suporte é oferecido por e-mail, WhatsApp, chat e atendimento ao vivo. Nos planos pagos, há prioridade, com resposta em até 2 horas durante o horário comercial.",
  },
  {
    title: "POSSO CRIAR MEUS PRÓPRIOS MATERIAIS NA PLATAFORMA?",
    description:
      "Sim. Você pode produzir vídeos personalizados, montar exercícios específicos e desenvolver conteúdos exclusivos para seus pacientes, além de utilizar a biblioteca de materiais prontos.",
  },
  {
    title: "POSSO ACOMPANHAR O PROGRESSO DOS MEUS PACIENTES?",
    description:
      "Sim. A plataforma oferece relatórios detalhados com informações sobre engajamento, progresso nos exercícios, frequência de uso e feedback dos pacientes, tudo em tempo real.",
  },
];
